import { render } from "./paihangbang.vue?vue&type=template&id=40dc78c2&scoped=true"
import script from "./paihangbang.vue?vue&type=script&lang=js"
export * from "./paihangbang.vue?vue&type=script&lang=js"

import "./paihangbang.vue?vue&type=style&index=0&id=40dc78c2&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40dc78c2"]])

export default __exports__